import React from "react";
import { Link } from "gatsby";
import ObfuscatedLink from "../obfuscated-link";

const TopNav = () => {
  const links = [
    // {
    //   url: "#",
    //   label: "À propos",
    //   items: [
    //     { label: "Qui sommes nous", url: "/l-atelier-du-tote-bag" },
    //     { label: "Nos engagements", url: "/l-atelier-du-tote-bag" }
    //   ]
    // },
    { url: "/l-atelier-du-tote-bag", label: "Qui sommes-nous", hideMobile: true },
    { url: `/contacter-l-atelier-du-tote-bag`, label: "Contact", hideMobile: false },
    { url: "/tote-bags-inspirations", label: "Nos réalisations", hideMobile: true },
    // { url: "/auteur-jonathan", label: "Le blog" }
  ];

  return (
    <div id="top-bar" className="bg-blue-hover block">
      <div className="container flex  lg:flex-row flex-col-reverse justify-center py-2 lg:justify-between flex-wrap items-center">
        <div className="text-white text-xs uppercase font-semibold text-center md:text-left hidden lg:block">Pour toute demande de devis urgente :
          <ObfuscatedLink className="text-white" to="mailto:devis@latelierdutotebag.com">devis@latelierdutotebag.com</ObfuscatedLink></div>
        <div className="flex justify-end ">
          <div className="">
            <ul
              className="top-bar-nav flex items-center mb-0 uppercase text-xs"
            >
              {links.map((link, i) => (
                <li key={i}>
                  {link.items && (
                    <div to={link.url} className="group relative flex flex-col text-white">
                      <div>{link.label}</div>
                      <ul className="hidden group-hover:block subMenu top-4">
                        {link.items.map((item, j) => (
                          <li key={j} className={`group/item ${link.hideMobile ? 'hidden lg:block' : 'block'}`}>
                            <ObfuscatedLink className={`group-hover/item:text-white`} to={item.url}>{item.label}</ObfuscatedLink>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {!link.items && (
                    <ObfuscatedLink to={link.url} className={`group relative flex flex-col text-white ${link.hideMobile ? 'hidden lg:block' : 'block'}`}>{link.label}</ObfuscatedLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
};

export default TopNav;
